module.exports = __webpack_public_path__ + "static/googlePlay-dc6c1b6664a668899ad79edb0317ed5b.png";